export const BoxStyle = [
    {id: 0, name: "Universal"},
    {id: 1, name: "Flat"},
    {id: 2, name: "Tuckin"},
]; 


